import React, { useEffect, useState } from "react";
import { Box, Grid, Card, CardContent, Typography, Button } from "@mui/material";
import { AttachMoney, ShoppingCart, Category, Star } from "@mui/icons-material";
import statsData from "../../Data/stats.json"; 

const iconMapping = {
  AttachMoney: <AttachMoney fontSize="medium" />,
  ShoppingCart: <ShoppingCart fontSize="medium" />,
  Category: <Category fontSize="medium" />,
  Star: <Star fontSize="medium" />,
};

const StatsCards = () => {
  const [stats, setStats] = useState([]);

  useEffect(() => {
    setStats(statsData); 
  }, []);

  return (
    <Box sx={{ p: 2 }}>
      <Box sx={{ textAlign: "right", mt: 2 }}>
        <Button
          variant="contained"
          size="small"
          sx={{
            backgroundColor: "#3bb77e",
            "&:hover": {
              backgroundColor: "#35a765", 
            },
          }}
        >
          Create Report
        </Button>
      </Box>

      <Typography variant="h5" sx={{ fontWeight: "bold" }} gutterBottom>
        Dashboard
      </Typography>
      <Typography
        variant="subtitle1"
        color="text.secondary"
        sx={{ fontWeight: "bold" }}
        gutterBottom
      >
        Whole data about your business here
      </Typography>
      <Grid container spacing={2}>
        {stats.map((stat, index) => (
          <Grid item xs={12} sm={6} md={3} key={index}>
            <Card
              variant="outlined"
              sx={{
                textAlign: "center",
                p: 1,
                borderRadius: 2,
                boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.1)",
              }}
            >
              <CardContent sx={{ p: 1 }}>
                <Box sx={{ color: stat.color }}>{iconMapping[stat.icon]}</Box>
                <Typography variant="subtitle1" sx={{ mt: 1 }}>
                  {stat.title}
                </Typography>
                <Typography variant="h6" sx={{ fontWeight: "bold", mt: 1 }}>
                  {stat.value}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {stat.description}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default StatsCards;
